import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { getMonth, getYear } from 'date-fns'
import { format } from 'date-fns'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import { FormControl } from '../../FormControl'
import { OldSelect, OldSelectOption } from '../../OldSelect'

function range(start: number, end: number) {
  return Array.from({ length: end - start + 1 }, (_, i) => i + start)
}

const years = range(2019, getYear(new Date()) + 1)

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export interface DatePickerHeaderProps extends ReactDatePickerCustomHeaderProps {
  showMonthAndYearSelector: boolean
}
export function DatePickerHeader({
  date,
  monthDate,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  showMonthAndYearSelector,
}: DatePickerHeaderProps) {
  if (showMonthAndYearSelector)
    // FormControl is used to override the parent FormControl usages. Otherwise, using DatePicker with FormControl
    // would make all internal fields of DatePicker red in case of isInvalid
    return (
      <FormControl className='flex gap-1'>
        <div className='w-full max-w-[100px]'>
          <OldSelect
            value={getYear(date)}
            displayValue={(value) => value.toString()}
            onChange={(value) => changeYear(value)}
            buttonProps={{ 'aria-label': 'Select year from list' }}
          >
            {years.map((option) => (
              <OldSelectOption key={option} value={option} aria-label={`Choose ${option}`}>
                {option}
              </OldSelectOption>
            ))}
          </OldSelect>
        </div>
        <div className='w-full'>
          <OldSelect
            value={months[getMonth(date)]}
            displayValue={(value) => value}
            onChange={(value) => changeMonth(months.indexOf(value))}
            buttonProps={{ 'aria-label': 'Select Month From List' }}
          >
            {months.map((option) => (
              <OldSelectOption key={option} value={option} aria-label={`Choose ${option}`}>
                {option}
              </OldSelectOption>
            ))}
          </OldSelect>
        </div>
      </FormControl>
    )

  return (
    <div className='flex items-center font-inter'>
      <h2 className='flex-auto text-left text-base font-semibold text-gray-900'>
        {format(monthDate, 'MMMM yyyy')}
      </h2>
      <button
        type='button'
        className='-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500'
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        <span className='sr-only'>Previous month</span>
        <ChevronLeftIcon className='h-5 w-5' aria-hidden='true' />
      </button>
      <button
        type='button'
        className='-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500'
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        <span className='sr-only'>Next month</span>
        <ChevronRightIcon className='h-5 w-5' aria-hidden='true' />
      </button>
    </div>
  )
}
